import React from 'react';

import ServicesContainer from '@totem/components/administration/services/ServicesContainer';
import ServicesLayout, {
  ServicesExtra,
} from '@totem/components/administration/services/ServicesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const ServicesPage = () => (
  <ContentLayout>
    <ServicesContainer>
      <IBCard isCovered title="Service Definitions" extra={<ServicesExtra />}>
        <ServicesLayout />
      </IBCard>
    </ServicesContainer>
  </ContentLayout>
);

export default ServicesPage;
